interface FooterLink {
  label: string
  href: string
}

interface FooterProps {
  links?: FooterLink[]
}

const defaultLinks: FooterLink[] = [
  { label: 'Help', href: '/help' },
  { label: 'Privacy', href: '/privacy' },
]

export function Footer({ links = defaultLinks }: FooterProps) {
  const currentYear = new Date().getFullYear()

  return (
    <footer className="py-8 border-t border-swiss-gray-200 mt-16">
      <div className="flex justify-between items-center text-[12px] text-swiss-gray-500 max-w-[1440px] mx-auto px-12">
        <span>&copy; {currentYear} Derivative Industries</span>
        <div className="flex gap-6">
          {links.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className="cursor-pointer transition-colors duration-150 hover:text-swiss-black"
            >
              {link.label}
            </a>
          ))}
        </div>
      </div>
    </footer>
  )
}
